import { render } from "./CreateNewClient.vue?vue&type=template&id=5b146afe"
import script from "./CreateNewClient.vue?vue&type=script&lang=js"
export * from "./CreateNewClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__